// TODO fix CONSTS
// TODO figure out why this can't be checked for definition
// NOTE This is the base element that sets the configuration of all other elements
class TDBaseElement extends HTMLElement {
  constructor() {
    super()
    this.MOBILE_MEDIA_QUERY = '(max-width: 1024px)'
    this.CURRENCY = Shopify.currency.active;
    this.LANGUAGE = 'en-US';
    this.MONEY_FORMATTER = new Intl.NumberFormat(this.LANGUAGE, {
      style: 'currency',
      currency: this.CURRENCY,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol',
    });

    this.unsubscibeFunctions = []
  }
  disconnectedCallback() {
    this.unsubscibeFunctions.forEach((func) => func())
    this.destroyFunction()
  }
  connectedCallback() {
    // NOTE this is to handle a legacy Firefox bug
    setTimeout(() => {
      this.initializationFunction()
    }) 
  }
  initializationFunction() {
    // Stub for initialization cleanup
  }
  destroyFunction() {
    // Stub for disconnected cleanup
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  checkIsMobile() {
    return window.matchMedia(this.MOBILE_MEDIA_QUERY).matches
  }
  formatMoney(amount) {
    return this.MONEY_FORMATTER.format(amount)
  }
}
customElements.define('td-base-element', TDBaseElement)

// NOTE this represents a collection filter
if (!customElements.get('bundle-filter')) {
  class BundleFilter extends TDBaseElement {

    constructor() {
      super()
      this.FILTER_VALUE = this.dataset.collection
      this.active = this.dataset.active && this.dataset.active != 'false'
    }

    initializationFunction() {
      if (this.FILTER_VALUE) {
        this.attachListeners()
        this.subscribeToEvents()
      } else {
        console.warn("Bundle Filter | Configuration Error: Collection Missing", this)
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFiltered, this.handleFilterChanged.bind(this)))
    }
    attachListeners() {
      this.addEventListener('click', this.handleClick.bind(this))
    }
    handleClick(e) {
      if (!this.active) {
        this.active = true
        this.setAttribute('data-active', true)
        publish(PUB_SUB_EVENTS.bundleFiltered, {filterValue: this.FILTER_VALUE})
      }
    }
    handleFilterChanged(e) {
      if (e.filterValue !== this.FILTER_VALUE) {
        this.active = false
        this.setAttribute('data-active', false)
      } else {
        this.active = true
        this.setAttribute('data-active', true)
      }
    }
  }

  customElements.define('bundle-filter', BundleFilter)

  class SelectBundleFilter extends BundleFilter {
    constructor() {
      super()
      this.SELECT_FIELD = this.querySelector('select')
      this.OPTIONS_CONTAINER = this.querySelector('.td-bb__custom-select--options')
      this.SELECTED_TEXT_WRAPPER = this.querySelector('.td-bb__custom-select--selected')
      this.ACTIVE_OPTION_CLASS = 'td-bb__custom-select-option--active'

      this.options = []
      this.isExpanded = false
    }
    initializationFunction() {
      if (!this.SELECT_FIELD) {
        console.warn("Bundle Filter | Configuration Error: Select Missing", this)
        return
      }
      if (!this.OPTIONS_CONTAINER) {
        console.warn("Bundle Filter | Configuration Error: Options Missing", this)
        return
      }
      if (!this.SELECTED_TEXT_WRAPPER) {
        console.warn("Bundle Filter | Configuration Error: Selected Text Missing", this)
        return
      }
      this.options = this.OPTIONS_CONTAINER.querySelectorAll('div')
      this.attachListeners()
      this.subscribeToEvents()
    }
    attachListeners() {
      this.addEventListener('click', this.handleClick.bind(this))
      this.SELECT_FIELD.addEventListener('change', this.handleSelectChange.bind(this))
      this.options.forEach((elm) => elm.addEventListener('click', this.handleOptionClicked.bind(this)))
    }
    handleClick() {
      if (!this.isExpanded) {
        document.addEventListener('click', this.maybeHandleClickOutside.bind(this))
        this.OPTIONS_CONTAINER.style.maxHeight = `${this.OPTIONS_CONTAINER.scrollHeight > 350 ? 350 : this.OPTIONS_CONTAINER.scrollHeight}px`
      } else {
        this.OPTIONS_CONTAINER.style.maxHeight = null
        document.removeEventListener('click', this.maybeHandleClickOutside)
      }
      this.isExpanded = !this.isExpanded
      this.setAttribute('data-expanded', this.isExpanded)
    }
    handleOptionClicked(e) {
      const clickedOption = e.target
      if (!clickedOption.classList.contains(this.ACTIVE_OPTION_CLASS)) {
        this.options.forEach((option) => {
          if (option.classList.contains(this.ACTIVE_OPTION_CLASS)) {
            option.classList.remove(this.ACTIVE_OPTION_CLASS)
          }
        })
        clickedOption.classList.add(this.ACTIVE_OPTION_CLASS)
        this.SELECTED_TEXT_WRAPPER.innerHTML = clickedOption.innerText
        this.SELECT_FIELD.value = clickedOption.dataset.option
        this.SELECT_FIELD.dispatchEvent(new Event('change'))
      }
    }
    maybeHandleClickOutside(e) {
      if (!this.contains(e.target)) {
        this.OPTIONS_CONTAINER.style.maxHeight = null
        this.isExpanded = false
        this.setAttribute('data-expanded', this.isExpanded)
        document.removeEventListener('click', this.maybeHandleClickOutside)
      }
    }
    handleSelectChange(e) {
      publish(PUB_SUB_EVENTS.bundleFiltered, {filterValue: this.SELECT_FIELD.value})
    }
    handleFilterChanged(e) {
      this.SELECT_FIELD.querySelectorAll('option').forEach((option) => {
        if (option.value !== e.filterValue) {
          option.removeAttribute('selected')
        } else {
          option.setAttribute('selected','')
        }
      })
    } 
  }

  customElements.define('select-bundle-filter', SelectBundleFilter)
}

// NOTE this represents a collection, will need to handle ajax pagination if needed
if (!customElements.get('bundle-facet')) {
  class BundleFacet extends TDBaseElement {

    constructor() {
      super()
      // NOTE this is being turned off for the time being
      this.ANIMATION_DELAY = 0
      // NOTE THIS IS TO COME FROM THE CUSTOMIZER
      this.PAGE_SIZE = this.dataset.pageSize
      this.PAGE_PARAM = "page"
      this.BASE_URL = window.location.pathname
      this.SECTION_PARAM = 'sections'
      this.REQUESTED_SECTION_ID = 'bundle-builder-products'
      this.COLLECTION = this.dataset.collection
      this.COLLECTION_HANDLE = this.dataset.collectionHandle
      this.PAGINATE = this.dataset.paginate && this.dataset.active != 'false'
      this.CHILDREN_SELECTOR = 'bundle-product'
      this.OBSERVER_OPTIONS = {}
      this.ITEM_LOAD_IN_CLASS = 'td-bb__load-in'
      // NOTE index back from end, this will allow us to watch at least 3 rows on desktop
      // this needs to be made a variable, this is being hardcoded for speed atm
      this.SENTINEL_INDEX = 3

      this.active = this.dataset.active && this.dataset.active != 'false'
      // Starts at the second page
      this.page = 2
      this.observer = null
      this.sentinel = null
      this.tags_filter = this.dataset.tagsFilter || false
      this.options_filter = this.dataset.optionsFilter || false
    }
    initializationFunction() {
      if (this.COLLECTION) {
        this.subscribeToEvents()
        if (this.PAGINATE) {
          this.configureObserver()
        }
      } else {
        console.warn("Bundle Facet | Configuration Error: Collection Missing", this)
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFiltered, this.handleFacetChanged.bind(this)))
    }
    handleFacetChanged(e) {
      if (e.filterValue === this.COLLECTION) {
        this.handleFacetActivation()
      } else if (this.active) {
        this.handleFacetDeactivation()
      }
    }
    handleFacetActivation() {
      const unsub = subscribe(PUB_SUB_EVENTS.bundleFacetChanged, () => {
        unsub()
        this.active = true
        // TODO figure out issue with StickyNav
        window.scrollTo(this.scrollTop,0)
        this.setAttribute('data-active', true)
      })
    }
    handleFacetDeactivation() {
      this.active = false
      this.addEventListener('transitionend', () => {
        publish(PUB_SUB_EVENTS.bundleFacetChanged)
      })
      this.setAttribute('data-active', false)
    }
    configureObserver() {
      const possibleTargets = this.querySelectorAll(this.CHILDREN_SELECTOR)
      if (possibleTargets.length && possibleTargets[possibleTargets.length - 1 - this.SENTINEL_INDEX]) {
        this.sentinel  = possibleTargets[possibleTargets.length - 1 - this.SENTINEL_INDEX]
        if (this.sentinel) {
          const handler = (entries) => {
            if (entries[0].isIntersecting) {
              this.retrieveMoreOptions()
            }
          };
          this.observer = new window.IntersectionObserver(handler, this.OBSERVER_OPTIONS);
          this.observer.observe(this.sentinel);
        }
      }
    }
    retrieveMoreOptions() {
      const queryParams = new URLSearchParams();
      queryParams.set(this.PAGE_PARAM, this.page);
      queryParams.set(this.SECTION_PARAM, this.REQUESTED_SECTION_ID);
      const requestUrl = [`/collections/`, this.COLLECTION_HANDLE , "?", queryParams.toString()].join("")
      fetch(requestUrl).then(function (response) {
        return response.text();
      }).then((response) => {
        try {
          const jsonResponse = JSON.parse(response)
          const sectionContent = jsonResponse[this.REQUESTED_SECTION_ID]
          if (sectionContent) {
            const doc = new DOMParser().parseFromString(sectionContent, "text/html")
            const additionalResults = doc.querySelectorAll(this.CHILDREN_SELECTOR);
            if (additionalResults.length) {
              additionalResults.forEach((result, index) => {
                if (!this.filterValues(result.dataset.tags?.split(","), this.tags_filter)
                  || !this.filterValues(result.dataset.options?.split(","), this.options_filter)) return;
                result.classList.add(this.ITEM_LOAD_IN_CLASS)
                if (result.querySelector('img')) {
                  // NOTE Setting loading to eager to ensure that everything is loaded when it's visible
                  result.querySelector('img').setAttribute('loading','eager')
                }
                this.appendChild(result)
                setTimeout(() => {
                  result.classList.remove(this.ITEM_LOAD_IN_CLASS)
                }, this.ANIMATION_DELAY * (index + 1))
              })
              this.page += 1;
              if (this.PAGE_SIZE > additionalResults.length && this.sentinel) {
                this.observer.unobserve(this.sentinel);
              } else {
                this.configureObserver()
              }
            }
          }
        } catch (err) {
          // There was an error
          console.error("Something went wrong.", err);
        }
      })
    }

    filterValues(valuesToFilter, filters) {
      if (!filters) return true;
      let tagFound = false;
      for (let value of valuesToFilter) {
        if (filters.includes(value)) {
          tagFound = true;
          break;
        }
      }
      return tagFound;
    }
  }

  customElements.define('bundle-facet', BundleFacet)
}

// NOTE this represents a pre-built collection that user is prompted to add, adds these to the builder
if (!customElements.get('bundle-prompt')) {
  class BundlePrompt extends TDBaseElement {

    constructor() {
      super()
      this.PRODUCTS = this.dataset.products?.split(',') || []

      this.PROMPT_HEADING = this.querySelector('.td-bb__prompt-content')
      this.PROMPT_TRIGGER = this.querySelector('.td-bb__prompt-trigger')

      this.SELECTED_PROMPT = this.dataset.selectedPrompt
      this.UNSELECTED_PROMPT = this.dataset.unselectedPrompt
      this.SELECTED_TEXT = this.dataset.selected
      this.UNSELECTED_TEXT = this.dataset.unselected

      this.isSet = false
    }

    initializationFunction() {
      if (!this.PROMPT_HEADING) {
        console.warn("Bundle Prompt | Configuration Error: Heading Missing")
        return
      }
      if (!this.PROMPT_TRIGGER) {
        console.warn("Bundle Prompt | Configuration Error: Trigger Missing")
        return
      }
      this.addEventListeners()
      this.subscribeToEvents()
    }

    addEventListeners() {
      this.PROMPT_TRIGGER.addEventListener('click', this.handlePromptClick.bind(this))
      // this.addEventListener('click',this.handlePromptClick.bind(this))
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFilled, this.handleBundleFilled.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleOpen, this.handleBundleOpen.bind(this)))
    }

    handlePromptClick() {
      if (!this.isSet) {
        this.PRODUCTS.forEach((product) => {
          // NOTE this will catch the first instance of the matching bundle product and dispatch an event to run
          // the needed update
          const matchingProduct = document.querySelector(`bundle-product[data-variant-id="${product}"]`)
          if (matchingProduct) {
            matchingProduct.dispatchEvent(new CustomEvent('prompt-product-added'))
          }
        })
        this.setAttribute('data-active', this.isSet)
        // this.PROMPT_TRIGGER.innerHTML = this.SELECTED_TEXT
      }
      
    }
    handleBundleFilled() {
      this.PROMPT_HEADING.innerHTML = this.SELECTED_PROMPT
      this.isSet = true
      this.setAttribute('data-active', this.isSet)
      this.PROMPT_TRIGGER.innerHTML = this.SELECTED_TEXT

    }
    handleBundleOpen() {
      this.PROMPT_HEADING.innerHTML = this.UNSELECTED_PROMPT
      this.isSet = false
      this.setAttribute('data-active', this.isSet)
      this.PROMPT_TRIGGER.innerHTML = this.UNSELECTED_TEXT
    }
  }

  customElements.define('bundle-prompt', BundlePrompt)
}

// NOTE this is an item that can be added to the bundle
if (!customElements.get('bundle-product')) {
  
  class BundleProduct extends TDBaseElement {

    constructor() {
      super()

      this.INCREMENTOR = this.querySelector('.td-bb__product-inc')
      this.DECREMENTOR = this.querySelector('.td-bb__product-dec')
      this.DETAIL_TRIGGER = this.querySelector('.td-bb__view-more-trigger')
      this.VIEW_MORE_ADD_SELECTOR = '.td-product-quickview__bundle-add'
      this.MODAL_SELECTOR ='.td-bb__modal'
      // TODO this should be moved over to a input field so that we can leverage debounce
      this.QTY_FIELD = this.querySelector('.td-bb__product-qty')
      this.IMAGE_SRC = this.dataset.image
      this.VARIANT_ID = this.dataset.variantId
      this.PRICE = this.dataset.price
      this.PRODUCT_TITLE = this.dataset.productTitle
      this.VARIANT_TITLE = this.dataset.variantTitle

      this.active = this.dataset.active && this.dataset.active != 'false'
      this.quantity = 0
      this.bundleFilled = false
    }
    initializationFunction() {
      if (this.INCREMENTOR || this.DECREMENTOR || this.DETAIL_TRIGGER) {
        this.attachListeners()
      }
      
      this.subscribeToEvents()
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleItemRemoved, this.handleBundleItemRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductAdded, this.handleBundleProductAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFilled, this.handleBundleFilled.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleOpen, this.handleBundleOpen.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleAdded, this.handleBundleClear.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleEmptied, this.handleBundleClear.bind(this)))
    }
    attachListeners() {
      this.addEventListener('prompt-product-added', this.handleIncrement.bind(this))
      if (this.INCREMENTOR) {
        this.INCREMENTOR.addEventListener('click', this.handleIncrement.bind(this))
      }
      if (this.DECREMENTOR) {
        this.DECREMENTOR.addEventListener('click', this.handleDecrement.bind(this))
      }
      if (this.DETAIL_TRIGGER) {
        this.DETAIL_TRIGGER.addEventListener('click', this.handleViewMore.bind(this))
      }
    }
    handleIncrement() {
      if (this.INCREMENTOR && !this.INCREMENTOR.disabled) {
        this.quantity += 1
      }
      this.handleUIUpdate()
      publish(PUB_SUB_EVENTS.bundleProductAdded, this.getItemObject())
    }
    handleDecrement() {
      this.quantity - 1 < 0 ? this.quantity = 0 : this.quantity -= 1
      this.handleUIUpdate()
      publish(PUB_SUB_EVENTS.bundleProductRemoved, this.getItemObject())
    }
    handleBundleClear() {
      this.quantity = 0
      this.handleUIUpdate()
      // publish(PUB_SUB_EVENTS.bundleProductRemoved, this.getItemObject())
    }
    handleUIUpdate() {
      if (this.quantity > 0) {
        this.active = true
      } else {
        this.active = false
      }
      this.setAttribute('data-active', this.active)

      if (this.DECREMENTOR) {
        this.DECREMENTOR.disabled = !this.active
      }

      if (this.QTY_FIELD) {
        this.QTY_FIELD.innerText = this.quantity
      }
    }
    handleBundleProductAdded(addedItem) {
      if (addedItem.variantId === this.VARIANT_ID && this !== addedItem.element ) {
        this.quantity += 1
        this.handleUIUpdate()
      }
    }
    handleBundleItemRemoved(removedItem) {
      // NOTE if it matches, decrement, otherwise, the bundle can be added to ensure that 
      // INCREMENTOR is not disabled 
      if (removedItem.variantId == this.VARIANT_ID) {
        this.quantity - 1 < 0 ? this.quantity = 0 : this.quantity -= 1
        this.handleUIUpdate()
      } else if (this.INCREMENTOR) {
        this.INCREMENTOR.disabled = false
      }
    }
    handleBundleOpen() {
      this.bundleFilled = false
      if (this.INCREMENTOR) {
        this.INCREMENTOR.disabled = false
      }
    }
    handleBundleFilled() {
      this.bundleFilled = true
      if (this.INCREMENTOR) {
        this.INCREMENTOR.disabled = true
      }
    }
    getItemObject() {
      return {
        image: this.IMAGE_SRC,
        variantId: this.VARIANT_ID,
        price: this.PRICE,
        productTitle: this.PRODUCT_TITLE,
        variantTitle: this.VARIANT_TITLE,
        element: this
      }
    }
    handleViewMore() {
      const modal = document.querySelector(this.MODAL_SELECTOR);
      // NOTE ensuring that modal functions as expected, implmentation could change
      if (modal && modal.show && modal.hide) { 
        modal.show(this.DETAIL_TRIGGER)
        modal.addEventListener('quickview:loaded', () => {
          const modalAdd = modal.querySelector(this.VIEW_MORE_ADD_SELECTOR)
          if (modalAdd) {
            if (this.bundleFilled) modalAdd.disabled = true
            modalAdd.addEventListener('click', () => {
              this.handleIncrement()
              modal.hide()
            })
          }
        }, {once:true})
      }
    }
  }

  customElements.define('bundle-product', BundleProduct)
}

// NOTE this is an item that has been added to the bundle
if (!customElements.get('bundle-item')) {
  
  class BundleItem extends TDBaseElement {

    constructor() {
      super()
      this.IMAGE_ELEMENT = this.querySelector('.td-bb__bundle-item--set img')
      this.HEADING_ELEMENT = this.querySelector('.td-bb__bundle-item--set .td-bb__item-heading')
      this.SUBHEADING_ELEMENT = this.querySelector('.td-bb__bundle-item--set .td-bb__item-subheading')
      this.DISCOUNTED_ELEMENT = this.querySelector('.td-bb__bundle-item--set .td-bb__discounted-price')
      this.PRICE_ELEMENT = this.querySelector('.td-bb__bundle-item--set .td-bb__price')
      this.REMOVER = this.querySelector('.td-bb__bundle-item--set .td-bb__item-remove')
      this.FOR_BLOCK = this.dataset.for
      this.IS_EXTRA = this.dataset.extra == "true";

      this.isSet = false
      this.variantId = null
      this.productTitle = null
      this.variantTitle = null
      this.price = null
      this.image = null
      this.discountAmount  = 0
    }

    initializationFunction() {
      this.attachListeners()
      this.subscribeToEvents()
    }
    attachListeners() {
      if (this.REMOVER) {
        this.REMOVER.addEventListener('click', this.removeBundleItem.bind(this))
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleDiscountSet, this.handleBundleDiscountSet.bind(this)))
      // this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleAdded, this.handleBundleAdded.bind(this)))
    }
    setItem({variantId, productTitle, variantTitle, price,image}, discount = false) {
      this.variantId = variantId
      this.productTitle = productTitle
      this.variantTitle = variantTitle
      this.price = price
      this.image = image
      this.isSet = true
      discount ? this.discountAmount = discount : null
      this.updateUI()
      // publish(PUB_SUB_EVENTS.bundleItemAdded, {forBlock: this.FOR_BLOCK})
    }
    updateUI() {
      // TODO add a loading state for the images
      if (this.isSet) {
        if (this.IMAGE_ELEMENT) {
          this.IMAGE_ELEMENT.src = this.image
          this,this.IMAGE_ELEMENT.alt = [this.productTitle, this.variantTitle].join(' ')
        }
        if (this.HEADING_ELEMENT) {
          this.HEADING_ELEMENT.innerHTML = this.productTitle
        }
        if (this.SUBHEADING_ELEMENT) {
          this.SUBHEADING_ELEMENT.innerHTML = this.variantTitle
        }
        // TODO handle the price formatting
        if (this.DISCOUNTED_ELEMENT) {
          const discountedPrice = this.price * (1 - this.discountAmount)
          this.DISCOUNTED_ELEMENT.innerHTML = discountedPrice != this.price ? this.formatMoney(discountedPrice / 100) : null
        }
        if (this.PRICE_ELEMENT) {
          this.PRICE_ELEMENT.innerHTML = this.formatMoney(this.price / 100)
        }
        
      } else {
        if (this.IMAGE_ELEMENT) {
          this.IMAGE_ELEMENT.src = null
        }
      }
      this.setAttribute('data-active', this.isSet)
    }
    removeBundleItem() {
      // NOTE this is a hotfix to prevent event from tripping twice?
      if (this.variantId) {
        const oldId = this.variantId
        this.resetData()
        this.updateUI()
        publish(PUB_SUB_EVENTS.bundleItemRemoved, {variantId: oldId, forBlock: this.FOR_BLOCK})
      }
    }
    handleBundleProductRemoved(removedProduct) {
      if (removedProduct.variantId == this.variantId) {
        this.removeBundleItem()
      }
    }
    handleBundleDiscountSet(newAmount) {
      this.discountAmount = newAmount
      this.updateUI()
    }
    resetData() {
      this.isSet = false
      this.variantId = null
      this.productTitle = null
      this.variantTitle = null
      this.price = null
      this.image = null
    }
    handleBundleAdded() {
      this.resetData()
      this.updateUI()
    }
    // NOTE this coupling isn't ideal but it is cleaner then any other solution
    clearItem() {
      if(this.IS_EXTRA) {
        this.remove()
        return
      }
      this.resetData()
      this.updateUI()
    }
    
  }

  customElements.define('bundle-item', BundleItem)
}

// NOTE this is the complete controller for the bundle builder
if (!customElements.get('bundle-controller')) {
  class BundleController extends TDBaseElement {

    constructor() {
      super()
      this.ACTION_ELEMENT = this.querySelector('.td-bb__action')
      this.ITEMS_CONTAINER = this.querySelector('.td-bb__items')
      this.PROGRESS_BAR = this.querySelector('bundle-progress-bar')
      // NOTE THIS NEEDS A DRAG LISTENER
      this.EXPANDER_ELEMENT = this.querySelector('.td-bb__expander')
      this.EXPANDING_ELEMENT = this.querySelector('.td-bb_expand-content')
      this.OVERLAY_ELEMENT = this.querySelector('.td-bb__overlay')

      this.ACTION_PRICE_SELECTOR = ".td-bb__action-price"
      this.ACTION_TEXT_SELECTOR = '.td-bb__action-text'
      this.SAVINGS_AMOUNT_SELECTOR = '.td-bb__savings-amount'
      this.MESSAGE_SELECTOR ='.td-bb__items-content'
      this.FREE_ITEM_SELECTOR = 'bundle-item--free[data-granted="true"]'

      this.CART_ENDPOINT = '/cart/add.js'
      this.BUNDLE_ITEM_LINE_ITEM_PROP = '__bb-bundle-item'
      this.GIFT_LINE_ITEM_PROP = '__bb-free-gift'
      
      this.bundleItemElements = [...this.querySelectorAll('bundle-item')]
      this.bundleItemsBaseSize = this.bundleItemElements.length;
      this.bundleItems = Array(this.bundleItemsBaseSize).fill(undefined)
      this.bundleGifts = []

      this.bundleTiers = [...this.querySelectorAll('bundle-tier')]

      this.discountAmount = 0
      this.isExpanded = false
      this.unlimitedProducts = this.dataset.unlimitedProducts == "true";
      this.skipCart = this.dataset.skipCart === 'true' || false;
  
      // TODO move the last discount here, then we push the call out to the items

    }

    initializationFunction() {
      if (!this.ITEMS_CONTAINER) {
        console.warn("Bundle Contoller | Configuration Error: Item Container Not Present")
        return
      }
      if (!this.ACTION_ELEMENT) {
        console.warn("Bundle Contoller | Configuration Error: Action Not Present")
        return
      }
      if (!this.bundleItems.length) {
        console.warn("Bundle Contoller | Configuration Error: Bundle Items Not Present")
        return
      }
      if (!this.bundleTiers.length) {
        console.warn("Bundle Contoller | Configuration Error: Bundle Tiers Not Present")
        return
      }
      this.addEventListeners()
      this.subscribeToEvents()
    }
    addEventListeners() {
        this.ACTION_ELEMENT.addEventListener('click', this.handleActionClicked.bind(this))
        if (this.EXPANDER_ELEMENT && this.EXPANDING_ELEMENT) {
          this.EXPANDER_ELEMENT.addEventListener('click', this.handleExpanderClicked.bind(this))
          if (this.OVERLAY_ELEMENT) {
            this.OVERLAY_ELEMENT.addEventListener('click', this.handleOverlayClicked.bind(this))
          }
        }
        
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductAdded, this.handleBundleProductAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductRemoved, this.handleBundleProductRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleItemRemoved, this.handleBundleProductRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleGiftGranted, this.handleBundleGiftAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleGiftRevoked, this.handleBundleGiftRemoved.bind(this)))
    }
    handleBundleProductAdded(addedProduct) {
      // TODO add checks that these properties exist
      const nextEmptyItem = this.bundleItems.findIndex((item) => !item)
      if (nextEmptyItem > -1) {
        this.bundleItems[nextEmptyItem] = addedProduct
      } else {
        this.bundleItems[this.bundleItems.length] = addedProduct;
      }
      this.updateUI()
      
    }
    handleBundleProductRemoved(removedProduct) {
      const lastMatching = [...this.bundleItems].reverse().findIndex((item) => item && item.variantId == removedProduct.variantId)
      if (lastMatching > -1) {
        this.bundleItems[ this.bundleItems.length - lastMatching - 1 ] = undefined
      }
      this.updateBundleOrdering()
      if (this.bundleIsEmpty()) publish(PUB_SUB_EVENTS.bundleEmptied)
      this.updateUI()
    }
    updateBundleOrdering() {
      if (!this.bundleIsEmpty()) {
        this.bundleItems.sort((a, b) => {
          if (a) {
            if (a && b) {
              return 0
            }
            return 1
          }
          return -1
        })
      }
    }
    bundleIsEmpty() {
      return this.bundleItems.filter((item) => !item).length == this.bundleItemElements.length
    }
    handleActionClicked(e) {
      e.preventDefault()
      const items = []
      const itemMapping = {}
      this.bundleItems.forEach((item) => {
        if (item) {
          if (!itemMapping[item.variantId]) {
            itemMapping[item.variantId] = 1
          } else {
            itemMapping[item.variantId] += 1
          }
        }
        
      })
      Object.keys(itemMapping).forEach((variantId) => {
          const itemObject = {
            id: variantId,
            quantity: itemMapping[variantId],
            properties: {
              "__bb-item": "true"
            }
          }
          itemObject.properties[this.BUNDLE_ITEM_LINE_ITEM_PROP] = "true"
          items.push(itemObject)
      })
      // this.bundleItems.forEach((item) => {
      //   if (item) {
      //     const itemObject = {
      //       id: item.variantId,
      //       quantity: 1,
      //       properties: {
      //         "__bb-item": true
      //       }
      //     }
      //     itemObject.properties[this.BUNDLE_ITEM_LINE_ITEM_PROP] = true
      //     items.push(itemObject)
      //   }
      // })
      // TODO CLEAN THIS UP
      this.ACTION_ELEMENT.classList.add('loading')
      this.ACTION_ELEMENT.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      this.bundleGifts.forEach((gift) => {
        const itemObject = {
          id: gift,
          quantity: 1,
          properties: {
          }
        }
        itemObject.properties[this.GIFT_LINE_ITEM_PROP] = "true"
        items.push(itemObject)
      })
      fetch(this.CART_ENDPOINT, {
        body: JSON.stringify({items}),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        method: "post"
      }).then((response) => {
        return response.json();
      }).then((json) => {
        publish(PUB_SUB_EVENTS.bundleAdded)
        this.bundleItems = Array(this.bundleItemElements.length).fill(undefined)
        this.updateUI()
        // Clear products open cart
        if (this.skipCart) {
          window.location.href = '/checkout';
        }
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.ACTION_ELEMENT.classList.remove('loading')
        this.ACTION_ELEMENT.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      });
    }
    updateUI() {
      this.updateBundleItemUI()
      this.updateBundleTiers()
      this.updateTotalsUI()
      this.updateMessaging()
    }
    updateBundleItemUI() {
      this.bundleItems.forEach((item, index, arr) => {
        if (item) {
          if (!this.bundleItemElements[index] && index == arr.length - 1) {
            this.bundleItemElements.push(this.createNewEmptyItem())
            this.bundleItemElements[index].setItem(item, this.discountAmount)
          } else {
            this.bundleItemElements[index].setItem(item)
          }
        } else {
          this.bundleItemElements[index].clearItem()
          if (index >= this.bundleItemsBaseSize && index == (arr.length - 1)) {
            this.bundleItemElements.splice(index, 1) 
            this.bundleItems.pop()
            this.querySelector('bundle-tier:last-child').remove()  
          }
        }
      })
      const hasExtra = this.bundleItemsBaseSize < this.bundleItems.length ? true : false
      this.classList.toggle('td-bb__has-extra', hasExtra);
    }
    updateBundleTiers() {
      let bundleDiscount = 0
      this.bundleItems.forEach((item, index) => {
        const itemElement = this.bundleTiers[index]
        if (item) {
          publish(PUB_SUB_EVENTS.bundleTierActivate, itemElement.getForBlock())
          const discountAmount = itemElement.getDiscountAmount()
          if (discountAmount > bundleDiscount) {
            bundleDiscount = discountAmount
          }
        } else {
          publish(PUB_SUB_EVENTS.bundleTierDeactivate, itemElement.getForBlock())
          itemElement.deactivateTier()
        }
      })
      this.discountAmount = bundleDiscount / 100
      publish(PUB_SUB_EVENTS.bundleDiscountSet, this.discountAmount)
      publish(PUB_SUB_EVENTS.updateProgressBar)

      if (this.bundleItems.filter((item) => !item).length > 0) {
        publish(PUB_SUB_EVENTS.bundleOpen)
      } else if(!this.unlimitedProducts) {
        publish(PUB_SUB_EVENTS.bundleFilled)
      }

    }
    updateTotalsUI() {
      const itemsTotal = this.bundleItems.reduce((acc, bundleItem) => {
        if (bundleItem) {
          return acc + (parseInt(bundleItem.price) * (1 - this.discountAmount))
        }
        return acc
      }, 0)
      const savingsAmount = this.bundleItems.reduce((acc, bundleItem) => {
        if (bundleItem) {
          return acc + ((parseInt(bundleItem.price) - (parseInt(bundleItem.price) * (1 - this.discountAmount))))
        }
        return acc
      }, 0)
      const freeGiftsAmount = [...this.querySelectorAll(this.FREE_ITEM_SELECTOR)].reduce((acc, item) => acc + item.getPrice(), 0)
      // NOTE if this is present there is two separate containers, otherwise it's just 1, replace the text
      const priceContainer = this.querySelector(this.ACTION_PRICE_SELECTOR)
      const textContainer = this.querySelector(this.ACTION_TEXT_SELECTOR)
      const savingsContainer = this.querySelector(this.SAVINGS_AMOUNT_SELECTOR)
      if (priceContainer) {
        // TODO GET A FORMATTER FUNCTION FOR PRICING
        priceContainer.innerHTML = this.formatMoney(itemsTotal / 100)
        if (itemsTotal) {
          textContainer.innerHTML = this.ACTION_ELEMENT.dataset.enabledText
          this.ACTION_ELEMENT.disabled = false
        }  else {
          textContainer.innerHTML = this.ACTION_ELEMENT.dataset.disabledText
          this.ACTION_ELEMENT.disabled = true
        }
      } else {
        if (itemsTotal) {
          this.ACTION_ELEMENT.innerHTML  = [this.ACTION_ELEMENT.dataset.enabledText, itemsTotal].join(' ')
          this.ACTION_ELEMENT.disabled = false
        }  else {
          textContainer.innerHTML = [this.ACTION_ELEMENT.dataset.disabledText, itemsTotal].join(' ')
          this.ACTION_ELEMENT.disabled = true
        }
      }
      if (savingsContainer) {
        savingsContainer.innerHTML = this.formatMoney((savingsAmount + freeGiftsAmount)/ 100)
      }
    }
    updateMessaging() {
      const lastActive =[...this.bundleTiers].reverse().find((tier) => tier.getIsActive())
      if (lastActive) {
        const messageContainer = this.querySelector(this.MESSAGE_SELECTOR)
        if (messageContainer) {
          messageContainer.innerHTML = lastActive.getTierMessage()
        }
      } else {
        const messageContainer = this.querySelector(this.MESSAGE_SELECTOR)
        if (messageContainer) {
          messageContainer.innerHTML = messageContainer.dataset.baseText
        }
      }

    }
    handleExpanderClicked() {
      // TODO this needs to dispatch an event that can handle the overlays + locking the screen
      this.isExpanded = !this.isExpanded
      this.setAttribute('data-expanded', this.isExpanded)
      if (this.isExpanded) {
        this.EXPANDING_ELEMENT.style.maxHeight = `${this.EXPANDING_ELEMENT.scrollHeight}px`
      } else {
        this.EXPANDING_ELEMENT.style.maxHeight = null
      }
      this.dispatchEvent(new CustomEvent('td-handle-scroll-lock', {bubbles:true}))
    }
    handleOverlayClicked() {
      if (this.isExpanded) {
        this.isExpanded = !this.isExpanded
        this.setAttribute('data-expanded', this.isExpanded)
        this.EXPANDING_ELEMENT.style.maxHeight = null
        this.dispatchEvent(new CustomEvent('td-handle-scroll-lock', {bubbles:true}))

      }
    }
    handleBundleGiftAdded(variant) {
      this.bundleGifts.push(variant)
    }
    handleBundleGiftRemoved(variant) {
      const variantIndex = this.bundleGifts.indexOf(variant)
      if (variantIndex > -1) {
       this.bundleGifts.splice (variantIndex, 1)
      }
    }
    createNewEmptyItem() {
      const newItem = this.querySelector(
        "[data-bundle-template='item']"
      ).content.firstElementChild.cloneNode(true);
      this.ITEMS_CONTAINER.appendChild(newItem);
      const newTier = this.querySelector(
        "[data-bundle-template='progress-bubble']"
      ).content.firstElementChild.cloneNode(true);
      this.PROGRESS_BAR.appendChild(newTier);      
      this.bundleTiers.push(this.querySelector('bundle-tier:last-child'));
      return this.querySelector('bundle-item:last-child');
    }
  }

  customElements.define('bundle-controller', BundleController)
}

if (!customElements.get('bundle-tier')) {
  class BundleTier extends TDBaseElement {
    // TODO these aren't working on mobile properly
    constructor() {
      super()
      this.TYPE = this.dataset.type
      this.DISCOUNT_AMOUNT = this.dataset.amount || 0
      this.TIER_MESSAGE = this.dataset.message
      // NOTE THIS IS USED TO TRIGGER RELATIONS BETWEEN TIER TYPINGS
      this.FOR_BLOCK = this.dataset.for
      this.IS_EXTRA = this.dataset.extra == 'true'
      this.SHORT_BAR = this.dataset.shortBar == 'true'

      this.active = false
    }

    initializationFunction() {
      this.subscribeToEvents()
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierActivate, this.activateTier.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierDeactivate, this.deactivateTier.bind(this)))
    }
    activateTier(forBlock) {
      if (!this.active && forBlock == this.FOR_BLOCK) {
        this.active = true
        this.setAttribute('data-active', this.active)
      }
    }
    
    deactivateTier(forBlock) {
      if(this.IS_EXTRA) {
        if (this.SHORT_BAR) {
          return
        }
        this.remove()
        return
      }
      if (this.active && forBlock == this.FOR_BLOCK) {
        this.active = false
        this.setAttribute('data-active', this.active)
      }
    }
    // NOTE this coupling isn't ideal but it works for the solution
    getDiscountAmount() {
      return this.DISCOUNT_AMOUNT
    }
    getForBlock() {
      return this.FOR_BLOCK
    }
    getIsActive() {
      return this.active
    }
    getTierMessage() {
      return this.TIER_MESSAGE
    }

  }

  customElements.define('bundle-tier', BundleTier)

  class BundleTierFree extends BundleTier {
    constructor() {
      super()
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierActivate, this.activateTier.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierDeactivate, this.deactivateTier.bind(this)))
    }

    activateTier(forBlock) {
      if (!this.active && forBlock == this.FOR_BLOCK) {
        this.active = true
        this.setAttribute('data-active', this.active)
      }
    }
    deactivateTier(forBlock) {
      if (this.active && forBlock == this.FOR_BLOCK) {
        this.active = false
        this.setAttribute('data-active', this.active)
      }

    }

  }
  customElements.define('bundle-tier--free',BundleTierFree)
}

if (!customElements.get('bundle-item--free')) {
  class BundleItemFree extends TDBaseElement {
    constructor() {
      super()
      this.FOR_BLOCK = this.dataset.for
      this.PRICE = parseInt(this.dataset.price) || 0
      this.VARIANT_ID = this.dataset.variant

      this.granted = false
    }

    initializationFunction() {
      this.subscribeToEvents()
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierActivate, this.activateTier.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierDeactivate, this.deactivateTier.bind(this)))
    }
    activateTier(forBlock) {
      if (!this.granted && forBlock == this.FOR_BLOCK) {
        this.granted = true
        this.setAttribute('data-granted', this.granted)
        publish(PUB_SUB_EVENTS.bundleGiftGranted, this.VARIANT_ID)
      }
    }
    deactivateTier(forBlock) {
      if (this.granted && forBlock == this.FOR_BLOCK) {
        this.granted = false
        this.setAttribute('data-granted', this.granted)
        publish(PUB_SUB_EVENTS.bundleGiftRevoked, this.VARIANT_ID)
      }
    }
    getPrice() {
      return this.PRICE
    }
  }

  customElements.define('bundle-item--free', BundleItemFree)
}

// NOTE this is the progress bar
if (!customElements.get('bundle-progress-bar')) {
  
  class BundleProgressBar extends TDBaseElement {
    // TODO Refactor
    constructor() {
      super()
  
      this.SIBLING_TAG_NAME = 'BUNDLE-TIER--FREE'
      this.CSS_VAR_X = '--td-bb__progress-bar-percentage-x'
      this.CSS_VAR_Y = '--td-bb__progress-bar-percentage-y'

      this.bundleTiers = [...this.querySelectorAll('bundle-tier')]
      this.isMobile = this.checkIsMobile()

    }
    initializationFunction() {
      if (!this.bundleTiers.length) {
        console.warn("Bundle Progress Bar | Configuration Error: Bundle Tiers")
        return
      }
      this.addEventListeners()
      this.subscribeToEvents()
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.updateProgressBar, this.updateProgressBar.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleItemAdded, this.updateProgressBar.bind(this)))

    }
    addEventListeners() {
      window.addEventListener('resize', this.debounce(this.handleWindowResize.bind(this), 1000))
    }
    handleWindowResize() {
      this.isMobile = this.checkIsMobile()
      this.updateProgressBar()
    }
    updateProgressBar() {
      const bundleTiersNoExtras = this.bundleTiers.filter((tier) => !tier.IS_EXTRA)
      const lastActiveTier = [...bundleTiersNoExtras].reverse().find((tier) => tier.getIsActive())
      if (lastActiveTier) {
        // If the last active tier is hit, fill the bar
        if (lastActiveTier == bundleTiersNoExtras[bundleTiersNoExtras.length - 1]) {
          this.style.setProperty(this.CSS_VAR_X,'100%')
          this.style.setProperty(this.CSS_VAR_Y,'100%')
        } else {
          let target = lastActiveTier
          if (target.nextElementSibling.tagName == this.SIBLING_TAG_NAME) {
            target = target.nextElementSibling
          }
          if (this.isMobile) {
            const boundingRect = target.getBoundingClientRect()
            const newX = ((boundingRect.left - (target.clientWidth / 2)) / this.clientWidth) * 100
            this.style.setProperty(this.CSS_VAR_X,`${newX}%`)
          } else {
            const newY = (1 - (this.clientHeight - (this.clientTop  + (target.offsetTop + (target.clientHeight / 2)))) / this.clientHeight) * 100
            this.style.setProperty(this.CSS_VAR_Y,`${newY}%`)
          }
        }

      } else {
        this.style.setProperty(this.CSS_VAR_X,'0%')
        this.style.setProperty(this.CSS_VAR_Y,'0%')
      }
    }


  }

  customElements.define('bundle-progress-bar', BundleProgressBar)
}

if (!customElements.get('td-bundle-builder')) {
  class TDBundleBuilder extends TDBaseElement {
    constructor() {
      super()
      this.SENTINEL_SELECTOR = '.td-bb__header'
      this.OBSERVER_CONFIGURATION = {}
      this.CSS_VAR_STICKY_OFFSET = '--td-sticky-offset'
      this.CSS_VAR_FIXED_OFFSET = '--td-fixed-offset'
      this.CSS_VAR_OUTER_HEIGHT = '--td-outer-height'

      this.FIXED_OFFSET_ELEMENT_SELECTORS = '#epb_background'
      this.STICKY_OFFSET_ELEMENT_SELECTORS = 'sticky-header, #epb_background'
      this.SCROLL_TOP_TRIGGER = this.querySelector('.td-bb__top-trigger')
      this.WRAPPER_SELECTOR = '.td-bb__item-area'

      this.LOCK_SCROLL_CLASS = 'td--lock-scroll'

      this.scrollIsLocked = false

      this.baseOuterHeight = 0
    }

    initializationFunction() {
      this.addEventListeners()
    }

    addEventListeners() {
      this.updateOffsets()
      window.addEventListener('resize', this.debounce(this.updateOffsets.bind(this), 1000))
      if (this.SCROLL_TOP_TRIGGER) {
        this.SCROLL_TOP_TRIGGER.addEventListener('click', this.handleScrollTopTrigger)
      }
      this.addEventListener('td-handle-scroll-lock', this.handleScrollLock.bind(this))
      const externalAppObserver = new MutationObserver( (mutations) => {
        if (document.querySelector('#epb_background')) {
          this.updateOffsets()
          externalAppObserver.disconnect();
        }
      });    
      externalAppObserver.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
    }
    destroyFunction() {
      window.removeEventListener('resize', this.debounce(this.updateStickyOffset.bind(this), 100))
    }     

    updateOffsets() {
      const stickyOffsetHeight = [...document.querySelectorAll(this.STICKY_OFFSET_ELEMENT_SELECTORS)].reduce((acc, element) => acc + element.clientHeight, 0 )
      const fixedOffsetHeight = [...document.querySelectorAll(this.FIXED_OFFSET_ELEMENT_SELECTORS)].reduce((acc, element) => acc + element.clientHeight, 0 )
      this.baseOuterHeight = this.baseOuterHeight || this.querySelector(this.WRAPPER_SELECTOR)?.clientHeight
      const outerHeight = this.baseOuterHeight + this.querySelector('.td-bb__items-header')?.clientHeight
      this.style.setProperty(this.CSS_VAR_STICKY_OFFSET,`${stickyOffsetHeight}px`)
      this.style.setProperty(this.CSS_VAR_FIXED_OFFSET,`${fixedOffsetHeight}px`)
      this.style.setProperty(this.CSS_VAR_OUTER_HEIGHT,`${outerHeight}px`)
    }

    handleScrollTopTrigger() {
      window.scrollTo(0,0)
    }
   
    handleScrollLock() {      
      const body = document.querySelector('body')
      if (body) {
        if (this.scrollIsLocked) {
          body.classList.remove(this.LOCK_SCROLL_CLASS)
          this.scrollIsLocked = false
        } else {
          body.classList.add(this.LOCK_SCROLL_CLASS)
          this.scrollIsLocked = true
        }
      }
    }
  }
  customElements.define('td-bundle-builder', TDBundleBuilder)
}